import { AbstractFormElement, ICustomFormElement } from "./Abstract";
import { postcodeValidator, postcodeValidatorExistsForCountry } from "postcode-validator";
import { attachSubmitWithEnter } from "./helper/Form";

// @ts-ignore
import countryMap from "../../../node_modules/country-locale-map/countries-intl.json";

class Zip extends AbstractFormElement implements ICustomFormElement {
    attachEvents(): this {
        attachSubmitWithEnter.call(this);
        return super.attachEvents();
    }

    /**
     * validation
     */
    validate() {
        let country = this.dataset.country;
        if (country.length > 2) {
            country = countryMap.find((c: { name: string; alpha2: string }) => c.name === country)?.alpha2;
        }
        country = country.toUpperCase();
        this.input.setCustomValidity("");
        if (this.required && postcodeValidatorExistsForCountry(country)) {
            if (this.input.value && !postcodeValidator(this.input.value, country)) {
                this.input.setCustomValidity("custom-error");
            }
        }
        return super.validate();
    }
}

Zip.prototype.template = document.createElement("template");

Zip.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-zip", Zip);

export { Zip };
